import * as React from 'react';

function SkipAllIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M6.7762 2.32294C7.10163 2.64837 7.10163 3.17601 6.7762 3.50145L4.26727 6.01038C4.11099 6.16666 3.89902 6.25446 3.67801 6.25445C3.457 6.25445 3.24504 6.16666 3.08876 6.01038L1.69917 4.62078C1.37373 4.29535 1.37373 3.76771 1.69917 3.44227C2.02461 3.11684 2.55224 3.11684 2.87768 3.44227L3.67801 4.24261L5.59769 2.32294C5.92312 1.9975 6.45076 1.9975 6.7762 2.32294Z"
        className="fill-icn-txt-prim"
      />
      <path
        d="M9.04023 3.33333C8.58 3.33333 8.2069 3.70643 8.2069 4.16667C8.2069 4.6269 8.58 5 9.04023 5H16.6666C17.1268 5 17.4999 4.6269 17.4999 4.16667C17.4999 3.70643 17.1268 3.33333 16.6666 3.33333H9.04023Z"
        className="fill-icn-txt-prim"
      />
      <path
        d="M9.04023 9.16667C8.58 9.16667 8.2069 9.53976 8.2069 10C8.2069 10.4602 8.58 10.8333 9.04023 10.8333H16.6666C17.1268 10.8333 17.4999 10.4602 17.4999 10C17.4999 9.53976 17.1268 9.16667 16.6666 9.16667H9.04023Z"
        className="fill-icn-txt-prim"
      />
      <path
        d="M8.2069 15.8333C8.2069 15.3731 8.58 15 9.04023 15H16.6666C17.1268 15 17.4999 15.3731 17.4999 15.8333C17.4999 16.2936 17.1268 16.6667 16.6666 16.6667H9.04023C8.58 16.6667 8.2069 16.2936 8.2069 15.8333Z"
        className="fill-icn-txt-prim"
      />
      <path
        d="M6.7762 9.33478C7.10163 9.00934 7.10163 8.48171 6.7762 8.15627C6.45076 7.83083 5.92312 7.83083 5.59769 8.15627L3.67801 10.0759L2.87768 9.27561C2.55224 8.95017 2.02461 8.95017 1.69917 9.2756C1.37373 9.60104 1.37373 10.1287 1.69917 10.4541L3.08876 11.8437C3.24504 12 3.457 12.0878 3.67801 12.0878C3.89902 12.0878 4.11099 12 4.26727 11.8437L6.7762 9.33478Z"
        className="fill-icn-txt-prim"
      />
      <path
        d="M6.77619 15.1637C7.10162 14.8382 7.10162 14.3106 6.77619 13.9851C6.45075 13.6597 5.92311 13.6597 5.59767 13.9851L3.678 15.9048L2.87767 15.1045C2.55223 14.779 2.02459 14.779 1.69916 15.1045C1.37372 15.4299 1.37372 15.9576 1.69915 16.283L3.08874 17.6726C3.24502 17.8289 3.45698 17.9167 3.678 17.9167C3.89901 17.9167 4.11097 17.8289 4.26726 17.6726L6.77619 15.1637Z"
        className="fill-icn-txt-prim"
      />
    </svg>
  );
}

export default SkipAllIcon;
